import React from 'react'
import { NavLink } from 'react-router-dom'

// Assets
import { OspreeLogoIcon } from 'assets/images/Icons'

// Styled Components
import { NotFoundWrapper, NotFoundLink, NotFoundText } from './NotFound.elements'

function NotFound() {
  return (
    <NotFoundWrapper>
      <NavLink to="/">
        <NotFoundLink>
          <OspreeLogoIcon />
        </NotFoundLink>
      </NavLink>
      <NotFoundText style={{ marginTop: '10px' }}>
        Error 404: The destination you are trying to access does not exist.
      </NotFoundText>
    </NotFoundWrapper>
  )
}

// Default Props
NotFound.defaultProps = {}

// Proptypes Validation
NotFound.propTypes = {}

export default NotFound
